(function () {
    'use strict';

    angular
        .module('blocks.multiselect', ['ng', 'blocks.lodash', 'pascalprecht.translate']);
})();